// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NaviagationItems__NavigationItems__bq96p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NaviagationItems.css
// module id = 293
// module chunks = 3